import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import QuotationContMain from "presentation/view/container/QuotationSetting/QuotationContMain";

CommonEntrypoint(<QuotationContMain />)